// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:opsz,wght@9..144,600;9..144,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --green-950: #12372a;
  --green-800: #1b513b;
  --green-700: #256a4b;
  --green-100: #dfeee5;
  --green-50: #eef7f1;
  --cream: #f8f7f2;
  --paper: #fffefa;
  --ink: #17201b;
  --muted: #667269;
  --line: #dde5df;
  --orange: #f28b44;
  --yellow: #f6d76f;
  --shadow: 0 18px 50px rgba(23, 49, 36, 0.09);
  --radius: 1.25rem;
  --font-sans: "DM Sans", sans-serif;
  --font-serif: "Fraunces", serif;
}

html {
  scroll-behavior: smooth;
}
body {
  margin: 0;
  background: var(--cream);
  color: var(--ink);
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
}
button,
input,
select {
  font: inherit;
}
img {
  max-width: 100%;
}
h1,
h2,
h3,
p {
  text-wrap: pretty;
}
h1,
h2 {
  font-family: var(--font-serif);
  letter-spacing: -0.035em;
}
a {
  color: inherit;
}
.min-w-0 {
  min-width: 0;
}
.narrow {
  max-width: 760px !important;
}
.text-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--green-700);
  font-weight: 700;
  text-decoration: none;
  font-size: 0.9rem;
}
.eyebrow,
.card-kicker {
  display: block;
  color: var(--green-700);
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.btn {
  min-height: 46px;
  border-radius: 0.85rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.btn-brand {
  background: var(--green-800);
  border-color: var(--green-800);
  color: white;
}
.btn-brand:hover,
.btn-brand:focus {
  background: var(--green-950);
  border-color: var(--green-950);
  color: white;
  transform: translateY(-1px);
}
.btn-soft {
  background: var(--green-50);
  border: 1px solid var(--green-100);
  color: var(--green-800);
}
.btn-soft:hover {
  background: var(--green-100);
  color: var(--green-950);
}
.btn-link {
  border: 0;
  padding: 0;
  background: none;
  color: var(--green-700);
  font-weight: 700;
}
.icon-button {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--line);
  border-radius: 50%;
  background: var(--paper);
  color: var(--ink);
  text-decoration: none;
  flex: 0 0 auto;
}
.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  color: var(--green-950);
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: -0.04em;
}
.brand-mark {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: yellow;
  background: var(--green-700);
  font-size: 0.8rem;
  transform: rotate(-16deg);
}
.topbar {
  position: fixed;
  z-index: 1030;
  inset: 0 0 auto;
  height: 72px;
  display: flex;
  align-items: center;
  background: rgba(255, 254, 250, 0.92);
  border-bottom: 1px solid rgba(221, 229, 223, 0.8);
  backdrop-filter: blur(16px);
}
.desktop-nav {
  display: none;
  align-items: center;
  gap: 0.2rem;
}
.desktop-nav a {
  padding: 0.6rem 0.85rem;
  color: var(--muted);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 10px;
}
.desktop-nav a:hover,
.desktop-nav a.active {
  color: var(--green-950);
  background: var(--green-50);
}
.profile-chip {
  display: none;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 0.8rem;
  border-radius: 50px;
  background: var(--green-950);
  color: white;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 700;
}
.location-button {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  background: transparent;
  border: 0;
  text-align: left;
}
.location-button > span:first-child {
  color: var(--green-700);
}
.location-button small,
.location-button strong {
  display: block;
  line-height: 1.15;
}
.location-button small {
  color: var(--muted);
  font-size: 0.65rem;
}
.location-button strong {
  font-size: 0.83rem;
}
.with-nav {
  padding-top: 72px;
  padding-bottom: 76px;
}
.bottom-nav {
  position: fixed;
  z-index: 1020;
  inset: auto 0 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  background: rgba(255, 254, 250, 0.96);
  border-top: 1px solid var(--line);
  backdrop-filter: blur(18px);
  padding: 0.45rem max(0.25rem, env(safe-area-inset-right))
    max(0.45rem, env(safe-area-inset-bottom));
}
.bottom-nav a {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  padding: 0.3rem 0;
  color: #849087;
  text-decoration: none;
  font-size: 0.65rem;
  font-weight: 700;
}
.bottom-nav i {
  font-size: 1rem;
}
.bottom-nav a.active {
  color: var(--green-700);
}
.page-wrap {
  padding-top: 1rem;
  padding-bottom: 5rem;
}
.page-header {
  margin-bottom: 1rem;
  max-width: 760px;
}
.page-header h1 {
  margin: 0.5rem 0;
  font-size: clamp(2.1rem, 5vw, 4.2rem);
  line-height: 0.98;
}
.page-header p {
  color: var(--muted);
  font-size: 1.05rem;
  max-width: 640px;
}
.section-space {
  padding: 2rem 0;
}
.section-heading {
  margin-bottom: 1.5rem;
}
.section-heading h2 {
  margin: 0.4rem 0;
  font-size: clamp(2rem, 4vw, 3.4rem);
}
.section-heading p {
  margin: 0;
  color: var(--muted);
  max-width: 620px;
}

@media (min-width: 576px) {
  .success-card {
    padding: 2.5rem;
  }
}

@media (min-width: 768px) {
  .onboarding {
    grid-template-columns: 1.1fr 0.9fr;
    grid-template-rows: 100svh;
  }
  .onboarding-image {
    margin: 1.5rem;
  }
  .onboarding-copy {
    padding: 4rem;
  }
  .hero-actions {
    flex-direction: row;
  }
  .steps-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .benefit-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  .market-banner div {
    padding: 2.5rem;
  }
  .detail-grid {
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
  .detail-image {
    position: sticky;
    top: 96px;
    height: calc(100vh - 130px);
  }
  .detail-copy {
    padding: 2rem 0;
  }
  .nutrition-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  .delivery-card > img {
    width: 110px;
    height: 110px;
  }
  .about-copy {
    padding-top: 5rem;
  }
}
@media (min-width: 992px) {
  .desktop-nav {
    display: flex;
  }
  .profile-chip {
    display: flex;
  }
  .bottom-nav {
    display: none;
  }
  .with-nav {
    padding-bottom: 0;
  }
  .page-wrap {
    padding-top: 4rem;
  }
}

/* Shared component styles */
.form-control,
.form-select,
.input-group-text {
  border-color: var(--line);
  border-radius: 12px;
  min-height: 48px;
}
.form-control:focus,
.form-select:focus {
  border-color: var(--green-700);
  box-shadow: 0 0 0 0.2rem rgba(37, 106, 75, 0.12);
}
.form-card {
  padding: 1.3rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.address-card {
  padding: 1.2rem;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: var(--paper);
  cursor: pointer;
}
.address-card.selected {
  border-color: var(--green-700);
  box-shadow: 0 0 0 2px rgba(37, 106, 75, 0.1);
}
.address-type,
.default-tag {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.address-type {
  color: var(--green-700);
}
.address-type i {
  margin-right: 0.35rem;
}
.default-tag {
  padding: 0.25rem 0.5rem;
  border-radius: 50px;
  color: var(--green-700);
  background: var(--green-50);
}
.address-card h3 {
  margin: 0.8rem 0 0.25rem;
  font-family: var(--font-sans);
  font-size: 0.95rem;
  font-weight: 800;
}
.address-card p {
  color: var(--muted);
  font-size: 0.85rem;
}
.address-card .btn-link {
  cursor: pointer;
}
.modal-content {
  border: 0;
  border-radius: var(--radius);
}
.modal-icon {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  margin: 0 auto 1rem;
  border-radius: 50%;
  color: var(--green-700);
  background: var(--green-50);
}
.delivery-list {
  display: grid;
  gap: 0.8rem;
}
.delivery-card {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.delivery-card > img {
  width: 76px;
  height: 90px;
  flex: 0 0 auto;
  object-fit: cover;
  border-radius: 14px;
}
.delivery-card h3 {
  font-family: var(--font-serif);
  font-size: 1.2rem;
}
.product-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
  transition:
    transform 0.2s,
    box-shadow 0.2s;
}
.product-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow);
}

.basket-product-image {
  display: block;
  overflow: hidden;
  position: relative;
}
/* Mobile */
.product-image {
  display: block;
  height: 535px;
  overflow: hidden;
  position: relative;
}

/* Tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  .product-image {
    height: 575px;
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .product-image {
    height: 615px;
  }
}
.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}
.product-card:hover img {
  transform: scale(1.03);
}
.product-card h3 {
  font-family: var(--font-serif);
  font-size: 1.4rem;
}
.price-pill {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.5rem 0.75rem;
  border-radius: 50px;
  color: var(--green-950);
  background: var(--yellow);
  font-weight: 800;
}
.nutrition-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--line);
  color: var(--green-800);
  font-size: 0.78rem;
  font-weight: 700;
}
.nutrition-disclaimer {
  margin-top: 1.5rem;
  color: var(--muted);
  font-size: 0.75rem;
}
.review-card {
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.review-product {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem;
  background: var(--green-50);
}
.review-product img {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 12px;
}
.review-product div {
  flex: 1;
}
.review-product h2 {
  margin: 0.2rem 0;
  font-family: var(--font-sans);
  font-size: 1rem;
  letter-spacing: 0;
  font-weight: 800;
}
.review-product p {
  margin: 0;
  color: var(--muted);
  font-size: 0.78rem;
}
.review-row {
  display: grid;
  grid-template-columns: 32px 1fr auto;
  gap: 0.6rem;
  padding: 1rem;
  border-top: 1px solid var(--line);
}
.review-row > i {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  color: var(--green-700);
  border-radius: 9px;
  background: var(--green-50);
}
.review-row span,
.review-row strong {
  display: block;
  font-size: 0.8rem;
}
.review-row span {
  color: var(--muted);
}
.review-row p {
  margin: 0.2rem 0 0;
  color: var(--muted);
  font-size: 0.76rem;
}
.review-row a {
  color: var(--green-700);
  font-size: 0.75rem;
  font-weight: 700;
}
.empty-state {
  padding: 3rem 1rem;
  text-align: center;
  border: 1px dashed var(--line);
  border-radius: var(--radius);
  background: var(--paper);
}
.empty-state > span {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  margin: 0 auto 1rem;
  border-radius: 18px;
  color: var(--green-700);
  background: var(--green-50);
  font-size: 1.4rem;
}
.empty-state h2 {
  font-size: 1.5rem;
}
.empty-state p {
  color: var(--muted);
}
.skeleton-card {
  height: 220px;
  padding: 1rem;
  border-radius: var(--radius);
  background: var(--paper);
}
.skeleton-card div,
.skeleton-card span {
  display: block;
  border-radius: 8px;
  background: linear-gradient(90deg, #edf0ed, #f7f8f7, #edf0ed);
  background-size: 200%;
  animation: shimmer 1.4s infinite;
}
.skeleton-card div {
  height: 130px;
}
.skeleton-card span {
  height: 12px;
  margin-top: 0.8rem;
}
.skeleton-card span:last-child {
  width: 60%;
}
@keyframes shimmer {
  to {
    background-position: -200%;
  }
}
.review-card {
}
@media (min-width: 768px) {
  .delivery-card > img {
    width: 110px;
    height: 110px;
  }
}

.choice-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.6rem;
}
.choice-grid button {
  min-height: 94px;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: white;
  position: relative;
  font-size: 0.78rem;
  font-weight: 700;
}
.choice-grid button > i:first-child {
  color: var(--green-700);
  font-size: 1.1rem;
}
.choice-grid button.selected,
.slot-list button.selected,
.day-grid button.selected {
  border-color: var(--green-700);
  color: var(--green-950);
  background: var(--green-50);
}
.choice-grid .check {
  position: absolute;
  right: 0.7rem;
  top: 0.7rem;
  color: var(--green-700);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;EAC5C,iBAAiB;EACjB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,6BAA6B;EAC7B,mCAAmC;AACrC;AACA;;;EAGE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;EAEE,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,YAAY;AACd;AACA;;EAEE,4BAA4B;EAC5B,8BAA8B;EAC9B,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,iDAAiD;EACjD,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,iCAAiC;EACjC,2BAA2B;EAC3B;6CAC2C;AAC7C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,4BAA4B;AAC5B;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,8BAA8B;EAC9B,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB;;mBAEiB;AACnB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA,WAAW;AACX;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;AACF;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;;EAEE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;AACA;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;;EAGE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:opsz,wght@9..144,600;9..144,700&display=swap\");\n\n:root {\n  --green-950: #12372a;\n  --green-800: #1b513b;\n  --green-700: #256a4b;\n  --green-100: #dfeee5;\n  --green-50: #eef7f1;\n  --cream: #f8f7f2;\n  --paper: #fffefa;\n  --ink: #17201b;\n  --muted: #667269;\n  --line: #dde5df;\n  --orange: #f28b44;\n  --yellow: #f6d76f;\n  --shadow: 0 18px 50px rgba(23, 49, 36, 0.09);\n  --radius: 1.25rem;\n  --font-sans: \"DM Sans\", sans-serif;\n  --font-serif: \"Fraunces\", serif;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\nbody {\n  margin: 0;\n  background: var(--cream);\n  color: var(--ink);\n  font-family: var(--font-sans);\n  -webkit-font-smoothing: antialiased;\n}\nbutton,\ninput,\nselect {\n  font: inherit;\n}\nimg {\n  max-width: 100%;\n}\nh1,\nh2,\nh3,\np {\n  text-wrap: pretty;\n}\nh1,\nh2 {\n  font-family: var(--font-serif);\n  letter-spacing: -0.035em;\n}\na {\n  color: inherit;\n}\n.min-w-0 {\n  min-width: 0;\n}\n.narrow {\n  max-width: 760px !important;\n}\n.text-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--green-700);\n  font-weight: 700;\n  text-decoration: none;\n  font-size: 0.9rem;\n}\n.eyebrow,\n.card-kicker {\n  display: block;\n  color: var(--green-700);\n  font-size: 0.88rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n.btn {\n  min-height: 46px;\n  border-radius: 0.85rem;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n.btn-brand {\n  background: var(--green-800);\n  border-color: var(--green-800);\n  color: white;\n}\n.btn-brand:hover,\n.btn-brand:focus {\n  background: var(--green-950);\n  border-color: var(--green-950);\n  color: white;\n  transform: translateY(-1px);\n}\n.btn-soft {\n  background: var(--green-50);\n  border: 1px solid var(--green-100);\n  color: var(--green-800);\n}\n.btn-soft:hover {\n  background: var(--green-100);\n  color: var(--green-950);\n}\n.btn-link {\n  border: 0;\n  padding: 0;\n  background: none;\n  color: var(--green-700);\n  font-weight: 700;\n}\n.icon-button {\n  width: 42px;\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--line);\n  border-radius: 50%;\n  background: var(--paper);\n  color: var(--ink);\n  text-decoration: none;\n  flex: 0 0 auto;\n}\n.brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  color: var(--green-950);\n  font-size: 1.3rem;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n}\n.brand-mark {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border-radius: 10px;\n  color: yellow;\n  background: var(--green-700);\n  font-size: 0.8rem;\n  transform: rotate(-16deg);\n}\n.topbar {\n  position: fixed;\n  z-index: 1030;\n  inset: 0 0 auto;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  background: rgba(255, 254, 250, 0.92);\n  border-bottom: 1px solid rgba(221, 229, 223, 0.8);\n  backdrop-filter: blur(16px);\n}\n.desktop-nav {\n  display: none;\n  align-items: center;\n  gap: 0.2rem;\n}\n.desktop-nav a {\n  padding: 0.6rem 0.85rem;\n  color: var(--muted);\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border-radius: 10px;\n}\n.desktop-nav a:hover,\n.desktop-nav a.active {\n  color: var(--green-950);\n  background: var(--green-50);\n}\n.profile-chip {\n  display: none;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.55rem 0.8rem;\n  border-radius: 50px;\n  background: var(--green-950);\n  color: white;\n  text-decoration: none;\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n.location-button {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  background: transparent;\n  border: 0;\n  text-align: left;\n}\n.location-button > span:first-child {\n  color: var(--green-700);\n}\n.location-button small,\n.location-button strong {\n  display: block;\n  line-height: 1.15;\n}\n.location-button small {\n  color: var(--muted);\n  font-size: 0.65rem;\n}\n.location-button strong {\n  font-size: 0.83rem;\n}\n.with-nav {\n  padding-top: 72px;\n  padding-bottom: 76px;\n}\n.bottom-nav {\n  position: fixed;\n  z-index: 1020;\n  inset: auto 0 0;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  background: rgba(255, 254, 250, 0.96);\n  border-top: 1px solid var(--line);\n  backdrop-filter: blur(18px);\n  padding: 0.45rem max(0.25rem, env(safe-area-inset-right))\n    max(0.45rem, env(safe-area-inset-bottom));\n}\n.bottom-nav a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.2rem;\n  padding: 0.3rem 0;\n  color: #849087;\n  text-decoration: none;\n  font-size: 0.65rem;\n  font-weight: 700;\n}\n.bottom-nav i {\n  font-size: 1rem;\n}\n.bottom-nav a.active {\n  color: var(--green-700);\n}\n.page-wrap {\n  padding-top: 1rem;\n  padding-bottom: 5rem;\n}\n.page-header {\n  margin-bottom: 1rem;\n  max-width: 760px;\n}\n.page-header h1 {\n  margin: 0.5rem 0;\n  font-size: clamp(2.1rem, 5vw, 4.2rem);\n  line-height: 0.98;\n}\n.page-header p {\n  color: var(--muted);\n  font-size: 1.05rem;\n  max-width: 640px;\n}\n.section-space {\n  padding: 2rem 0;\n}\n.section-heading {\n  margin-bottom: 1.5rem;\n}\n.section-heading h2 {\n  margin: 0.4rem 0;\n  font-size: clamp(2rem, 4vw, 3.4rem);\n}\n.section-heading p {\n  margin: 0;\n  color: var(--muted);\n  max-width: 620px;\n}\n\n@media (min-width: 576px) {\n  .success-card {\n    padding: 2.5rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .onboarding {\n    grid-template-columns: 1.1fr 0.9fr;\n    grid-template-rows: 100svh;\n  }\n  .onboarding-image {\n    margin: 1.5rem;\n  }\n  .onboarding-copy {\n    padding: 4rem;\n  }\n  .hero-actions {\n    flex-direction: row;\n  }\n  .steps-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .benefit-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .market-banner div {\n    padding: 2.5rem;\n  }\n  .detail-grid {\n    grid-template-columns: 1fr 1fr;\n    align-items: start;\n  }\n  .detail-image {\n    position: sticky;\n    top: 96px;\n    height: calc(100vh - 130px);\n  }\n  .detail-copy {\n    padding: 2rem 0;\n  }\n  .nutrition-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .delivery-card > img {\n    width: 110px;\n    height: 110px;\n  }\n  .about-copy {\n    padding-top: 5rem;\n  }\n}\n@media (min-width: 992px) {\n  .desktop-nav {\n    display: flex;\n  }\n  .profile-chip {\n    display: flex;\n  }\n  .bottom-nav {\n    display: none;\n  }\n  .with-nav {\n    padding-bottom: 0;\n  }\n  .page-wrap {\n    padding-top: 4rem;\n  }\n}\n\n/* Shared component styles */\n.form-control,\n.form-select,\n.input-group-text {\n  border-color: var(--line);\n  border-radius: 12px;\n  min-height: 48px;\n}\n.form-control:focus,\n.form-select:focus {\n  border-color: var(--green-700);\n  box-shadow: 0 0 0 0.2rem rgba(37, 106, 75, 0.12);\n}\n.form-card {\n  padding: 1.3rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.address-card {\n  padding: 1.2rem;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  background: var(--paper);\n  cursor: pointer;\n}\n.address-card.selected {\n  border-color: var(--green-700);\n  box-shadow: 0 0 0 2px rgba(37, 106, 75, 0.1);\n}\n.address-type,\n.default-tag {\n  font-size: 0.7rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n.address-type {\n  color: var(--green-700);\n}\n.address-type i {\n  margin-right: 0.35rem;\n}\n.default-tag {\n  padding: 0.25rem 0.5rem;\n  border-radius: 50px;\n  color: var(--green-700);\n  background: var(--green-50);\n}\n.address-card h3 {\n  margin: 0.8rem 0 0.25rem;\n  font-family: var(--font-sans);\n  font-size: 0.95rem;\n  font-weight: 800;\n}\n.address-card p {\n  color: var(--muted);\n  font-size: 0.85rem;\n}\n.address-card .btn-link {\n  cursor: pointer;\n}\n.modal-content {\n  border: 0;\n  border-radius: var(--radius);\n}\n.modal-icon {\n  width: 64px;\n  height: 64px;\n  display: grid;\n  place-items: center;\n  margin: 0 auto 1rem;\n  border-radius: 50%;\n  color: var(--green-700);\n  background: var(--green-50);\n}\n.delivery-list {\n  display: grid;\n  gap: 0.8rem;\n}\n.delivery-card {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.delivery-card > img {\n  width: 76px;\n  height: 90px;\n  flex: 0 0 auto;\n  object-fit: cover;\n  border-radius: 14px;\n}\n.delivery-card h3 {\n  font-family: var(--font-serif);\n  font-size: 1.2rem;\n}\n.product-card {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n  transition:\n    transform 0.2s,\n    box-shadow 0.2s;\n}\n.product-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow);\n}\n\n.basket-product-image {\n  display: block;\n  overflow: hidden;\n  position: relative;\n}\n/* Mobile */\n.product-image {\n  display: block;\n  height: 535px;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Tablet */\n@media (min-width: 768px) and (max-width: 1023px) {\n  .product-image {\n    height: 575px;\n  }\n}\n\n/* Desktop */\n@media (min-width: 1024px) {\n  .product-image {\n    height: 615px;\n  }\n}\n.product-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s;\n}\n.product-card:hover img {\n  transform: scale(1.03);\n}\n.product-card h3 {\n  font-family: var(--font-serif);\n  font-size: 1.4rem;\n}\n.price-pill {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 50px;\n  color: var(--green-950);\n  background: var(--yellow);\n  font-weight: 800;\n}\n.nutrition-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--line);\n  color: var(--green-800);\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n.nutrition-disclaimer {\n  margin-top: 1.5rem;\n  color: var(--muted);\n  font-size: 0.75rem;\n}\n.review-card {\n  overflow: hidden;\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.review-product {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 1rem;\n  background: var(--green-50);\n}\n.review-product img {\n  width: 64px;\n  height: 64px;\n  object-fit: cover;\n  border-radius: 12px;\n}\n.review-product div {\n  flex: 1;\n}\n.review-product h2 {\n  margin: 0.2rem 0;\n  font-family: var(--font-sans);\n  font-size: 1rem;\n  letter-spacing: 0;\n  font-weight: 800;\n}\n.review-product p {\n  margin: 0;\n  color: var(--muted);\n  font-size: 0.78rem;\n}\n.review-row {\n  display: grid;\n  grid-template-columns: 32px 1fr auto;\n  gap: 0.6rem;\n  padding: 1rem;\n  border-top: 1px solid var(--line);\n}\n.review-row > i {\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  color: var(--green-700);\n  border-radius: 9px;\n  background: var(--green-50);\n}\n.review-row span,\n.review-row strong {\n  display: block;\n  font-size: 0.8rem;\n}\n.review-row span {\n  color: var(--muted);\n}\n.review-row p {\n  margin: 0.2rem 0 0;\n  color: var(--muted);\n  font-size: 0.76rem;\n}\n.review-row a {\n  color: var(--green-700);\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n.empty-state {\n  padding: 3rem 1rem;\n  text-align: center;\n  border: 1px dashed var(--line);\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.empty-state > span {\n  width: 64px;\n  height: 64px;\n  display: grid;\n  place-items: center;\n  margin: 0 auto 1rem;\n  border-radius: 18px;\n  color: var(--green-700);\n  background: var(--green-50);\n  font-size: 1.4rem;\n}\n.empty-state h2 {\n  font-size: 1.5rem;\n}\n.empty-state p {\n  color: var(--muted);\n}\n.skeleton-card {\n  height: 220px;\n  padding: 1rem;\n  border-radius: var(--radius);\n  background: var(--paper);\n}\n.skeleton-card div,\n.skeleton-card span {\n  display: block;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #edf0ed, #f7f8f7, #edf0ed);\n  background-size: 200%;\n  animation: shimmer 1.4s infinite;\n}\n.skeleton-card div {\n  height: 130px;\n}\n.skeleton-card span {\n  height: 12px;\n  margin-top: 0.8rem;\n}\n.skeleton-card span:last-child {\n  width: 60%;\n}\n@keyframes shimmer {\n  to {\n    background-position: -200%;\n  }\n}\n.review-card {\n}\n@media (min-width: 768px) {\n  .delivery-card > img {\n    width: 110px;\n    height: 110px;\n  }\n}\n\n.choice-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.6rem;\n}\n.choice-grid button {\n  min-height: 94px;\n  padding: 0.8rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.45rem;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: white;\n  position: relative;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n.choice-grid button > i:first-child {\n  color: var(--green-700);\n  font-size: 1.1rem;\n}\n.choice-grid button.selected,\n.slot-list button.selected,\n.day-grid button.selected {\n  border-color: var(--green-700);\n  color: var(--green-950);\n  background: var(--green-50);\n}\n.choice-grid .check {\n  position: absolute;\n  right: 0.7rem;\n  top: 0.7rem;\n  color: var(--green-700);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
